import { GET_APPLICANT, GET_APPLICANT_SUCCESS, GET_APPLICANT_FAIL, DELETE_APPLICANT, DELETE_APPLICANT_SUCCESS, DELETE_APPLICANT_FAIL, UPDATE_APPLICANT, UPDATE_APPLICANT_SUCCESS, UPDATE_APPLICANT_FAIL, ADD_NEW_APPLICANT, ADD_APPLICANT_SUCCESS, ADD_APPLICANT_FAIL, APPLICANT_LOADING, APPLICANT_RESET, APPLICANT_RESET_CREATE, GET_APPLICANT_ONE } from "./actionType";

export const resetApplicantState = (actionType) => ({
  type: APPLICANT_RESET,
  payload: { actionType },
});

export const resetApplicantCreateState = (actionType) => ({
  type: APPLICANT_RESET_CREATE,
  payload: { actionType },
});

export const getApplicantSuccess = (actionType, data) => ({
  type: GET_APPLICANT_SUCCESS,
  payload: { actionType, data },
});

export const getApplicantFail = (actionType, error) => ({
  type: GET_APPLICANT_FAIL,
  payload: { actionType, error },
});

export const getApplicant = (data) => ({
  type: GET_APPLICANT,
  payload: data,
});

export const getApplicantOne = (data) => ({
  type: GET_APPLICANT_ONE,
  payload: data,
});

export const getApplicantLoading = () => ({
  type: APPLICANT_LOADING,
});

export const deleteApplicant = (data) => ({
  type: DELETE_APPLICANT,
  payload: data,
});

export const deleteApplicantSuccess = (data) => ({
  type: DELETE_APPLICANT_SUCCESS,
  payload: data,
});

export const deleteApplicantFail = (error) => ({
  type: DELETE_APPLICANT_FAIL,
  payload: error,
});

export const updateApplicant = (data) => ({
  type: UPDATE_APPLICANT,
  payload: data,
});

export const updateApplicantFail = (error) => ({
  type: UPDATE_APPLICANT_FAIL,
  payload: error,
});

export const updateApplicantSuccess = (data) => ({
  type: UPDATE_APPLICANT_SUCCESS,
  payload: data,
});

export const addNewApplicant = (data) => ({
  type: ADD_NEW_APPLICANT,
  payload: data,
});

export const addApplicantSuccess = (data) => ({
  type: ADD_APPLICANT_SUCCESS,
  payload: data,
});

export const addApplicantFail = (error) => ({
  type: ADD_APPLICANT_FAIL,
  payload: error,
});
